import { kebabCase } from 'lodash';

export const textVariants = {
  titilliumWeb64: {
    fontFamily: 'Titillium Web',
    fontSize: '64px',
    lineHeight: '64px',
    fontWeight: '600',
    letterSpacing: '0%',
  },
  titilliumWeb60: {
    fontFamily: 'Titillium Web',
    fontSize: '60px',
    lineHeight: '68px',
    fontWeight: '400',
    letterSpacing: '-1%',
  },
  titilliumWeb48: {
    fontFamily: 'Titillium Web',
    fontSize: '48px',
    lineHeight: '56px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  titilliumWeb32: {
    fontFamily: 'Titillium Web',
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  titilliumWeb24: {
    fontFamily: 'Titillium Web',
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '600',
    letterSpacing: '1%',
  },
  titilliumWeb20: {
    fontFamily: 'Titillium Web',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '700',
    letterSpacing: '3%',
  },
  titilliumWebBold16: {
    fontFamily: 'Titillium Web',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '700',
    letterSpacing: '6%',
  },
  titilliumWebSemiBold20: {
    fontFamily: 'Titillium Web',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '600',
    letterSpacing: '1%',
  },
  titilliumWebSemiBold24: {
    fontFamily: 'Titillium Web',
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '600',
    letterSpacing: '.18px',
  },
  titilliumWebSemiBold28: {
    fontFamily: 'Titillium Web',
    fontSize: '28px',
    lineHeight: '32px',
    fontWeight: '600',
    letterSpacing: '0.54px',
  },
  titilliumWebSemiBold36: {
    fontFamily: 'Titillium Web',
    fontSize: '36px',
    lineHeight: '56px',
    fontWeight: '600',
    letterSpacing: '1%',
  },
  titilliumWebSemiBold16: {
    fontFamily: 'Titillium Web',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '600',
    letterSpacing: '.96px',
  },
  titilliumWebBold14: {
    fontFamily: 'Titillium Web',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '700',
    letterSpacing: '5%',
  },
  titilliumWebSemiBold14: {
    fontFamily: 'Titillium Web',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '600',
    letterSpacing: '.7px',
  },
  titilliumWebBold12: {
    fontFamily: 'Titillium Web',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '700',
    letterSpacing: '8%',
  },
  titilliumWebSemiBold12: {
    fontFamily: 'Titillium Web',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '600',
    letterSpacing: '4%',
  },
  sourceSansPro24SemiBold: {
    fontFamily: 'Source Sans Pro',
    fontSize: '24px',
    lineHeight: '24px',
    fontWeight: '600',
    letterSpacing: '0%',
  },
  sourceSansPro24Regular: {
    fontFamily: 'Source Sans Pro',
    fontSize: '24px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  sourceSansPro20Regular: {
    fontFamily: 'Source Sans Pro',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  sourceSansPro11Regular: {
    fontFamily: 'Source Sans Pro',
    fontSize: '11px',
    lineHeight: '14px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  sourceSansPro18Regular: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  sourceSansPro18SemiBold: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '600',
    letterSpacing: '0%',
  },
  sourceSansPro18RegularLink: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '0%',
  },
  sourceSansPro18RegularMask: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '10%',
  },
  sourceSansPro18RegularNumberPlaceholder: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '10%',
  },
  sourceSansPro18RegularRegularTextPlaceholder: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '0%',
    fontStyle: 'italic',
  },
  sourceSansPro16Regular: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '400',
    letterSpacing: '1%',
  },
  sourceSansPro16RegularLink: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '400',
    letterSpacing: '1%',
  },
  sourceSansPro16SemiBold: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '600',
    letterSpacing: '1%',
  },
  sourceSansPro14SemiBold: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '600',
    letterSpacing: '1%',
  },
  sourceSansPro11SemiBold: {
    fontFamily: 'Source Sans Pro',
    fontSize: '11px',
    lineHeight: '14px',
    fontWeight: '600',
    letterSpacing: '.66px',
  },
  sourceSansPro10SemiBold: {
    fontFamily: 'Source Sans Pro',
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: '600',
    letterSpacing: '6%',
  },
};

export function transformVariants<T>() {
  return Object.entries(textVariants).map((value) => {
    const [name, styles] = value;
    return {
      props: { variant: kebabCase(name) as T },
      style: styles,
    };
  });
}
